import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SharedPagination from "../../modules/common/sharedPagination";
import "./style.css";
import { DownloadInvoiceList, FetchInvoiceList } from "../../redux/features/invoice/invoiceAction";
import { CommonTable } from "../../modules/common/table/Table";
import { invoiceListColumns } from "../../modules/common/table/columns/_invoiceListColumns";
import InvoiceModal from "./Invoice-modal";
import { setCloseInvalidRowsModal, setCloseInvoiceModal, setOpenInvoiceDataStoreModal, setOpenInvoiceModal, setOpenInvoiceUploadModal } from "../../redux/features/invoice/invoiceSlice";
import EditInvoiceModal from "./EditInvoiceModal";
import { FiSearch } from "react-icons/fi";
import InvoiceUploadModal from "./InvoiceUploadModal";
import { MESSAGES } from "../../utlis/messages";
import InvalidRowsModal from "./InvalidRowsModal";
import InvoiceDetailModal from "./InvoiceDetailModal";
import InvoiceDocumentUploadModal from "./InvoiceDocumentUploadModal";
import InvoiceDataStoreModal from "./InvoiceDataStoreModal";

const InvoicePage = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const limit = 10;

  const states = useSelector((state: any) => state.invoiceSlice);
  const invoiceList = states?.invoice || [];
  const totalRecord = states?.totalRecord || 0;
  const totalPages = Math.ceil(totalRecord / limit);


  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        await dispatch(FetchInvoiceList({
          page: currentPage,
          limit,
          search: searchQuery,
          fromDate,
          toDate,
        }));

      } catch (error) {
        console.error("Failed to fetch inventory:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [currentPage, searchQuery, fromDate, toDate]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const handleDownloadCSV = async () => {
    if (!invoiceList || invoiceList.length === 0) return;

    const response = await dispatch(DownloadInvoiceList());
    const allInvoice = response?.payload?.data || [];

    if (!allInvoice || allInvoice.length === 0) return;

    const headers = Object.keys(allInvoice[0]).map(key => key.toString());
    const csvRows: any = [];

    csvRows.push(headers.join("," as string));

    allInvoice.forEach(item => {
      const values = headers.map(header => {
        const val = item[header];
        const escaped = typeof val === "string" ? `"${val.replace(/"/g, '""')}"` : val;
        return escaped;
      });
      csvRows.push(values.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "inventory_export.csv";
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <>
      <div className="order-status-container">
        <div className="inventory-header">
          <h2 className="page-title">Invoice</h2>

          <div className="inventory-actions">

            <div className="upload-container">

              <div className="d-flex gap-2">
                {invoiceList.length > 0 && (
                  <label
                    className="upload-button"
                    onClick={() => dispatch(setOpenInvoiceModal({
                      isEditMode: true
                    }))}
                    style={{ cursor: "pointer" }}
                  >
                    Update Mapping
                  </label>
                )}

                <label
                  className="upload-button"
                  // onClick={() => dispatch(setOpenInvoiceUploadModal({}))}
                  onClick={() => dispatch(setOpenInvoiceDataStoreModal({}))}
                  style={{ cursor: "pointer" }}
                >
                  {MESSAGES.UPLOAD_INVOICE}
                </label>
              </div>
              <p className="upload-hint">* Accepted Files: CSV, XML o XLSX</p>
            </div>
            <div className="filters-wrapper d-flex align-items-end gap-3 flex-wrap">
              <div className="date-filter-group d-flex align-items-center gap-2">
                <label className="date-label">Da:</label>
                <input
                  type="date"
                  className="form-control date-input"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <label className="date-label">to:</label>
                <input
                  type="date"
                  className="form-control date-input"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>

              <div className="search-bar">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Find Invoice..."
                  className="form-control search-text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>

          </div>
        </div>

        <div className='orderListTable'>
          {loading ? (
            <p className="loading-text">Loading Invoice...</p>
          ) : invoiceList?.length > 0 ? (
            <CommonTable data={invoiceList} columns={invoiceListColumns} />
          ) : (
            <p className="no-orders">No invoice uploaded.</p>
          )}
        </div>

        <div className="footer-actions">
          {/* <button
            className="download-button"
            onClick={handleDownloadCSV}
            disabled={invoiceList.length === 0}
          >
            Scarica CSV
          </button> */}

          {totalRecord > 10 && <SharedPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />}
        </div>

        {states?.openInvoiceModal && (
          <InvoiceModal
            show={states?.openInvoiceModal}
            handleClose={() => dispatch(setCloseInvoiceModal())}
            data={states?.modalData?.data}
            headers={states?.modalData?.headers}
            rawFile={states?.modalData?.rawFile}
          />
        )}
        {states?.openInvalidRowsModal && (
          <InvalidRowsModal
            show={states.openInvalidRowsModal}
            onHide={() => dispatch(setCloseInvalidRowsModal())}
            invalidRows={states.invalidModalData?.data}
          />
        )}


        {states?.editInvoiceModalOpen && (
          <EditInvoiceModal />
        )}
        {states?.openInvoiceUploadModal && (
          <InvoiceUploadModal />
        )}
        {states?.openInvoiceListModal && (
          <InvoiceDetailModal />
        )}
        {states?.openDocumentUploadModal && (
          <InvoiceDocumentUploadModal />
        )}
        {states?.openInvoiceDataStoreModal && (
          <InvoiceDataStoreModal />
        )}

      </div>
    </>
  );
};

export default InvoicePage;
